import React from 'react';
import { Helmet } from "react-helmet";
import CarouselGolden from './CarouselGolden';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import VideoList from './VideoList';
import './Births.css';

import salou_1 from './video/salou_5.mp4';
import salou_2 from './video/salou_6.mp4';
import salou_3 from './video/salou_7.mp4';

import peat_1 from './video/peat_1.mp4';
import peat_2 from './video/peat_2.mp4';
import peat_3 from './video/peat_3.mp4';

const images = require.context('./img/golden/naissance/naissance_old', true);
const imageList = images.keys().map(image => images(image));

const images_salou = require.context('./img/golden/naissance/naissance_salou/current', true);
const imageList2 = images_salou.keys().map(image => images_salou(image));
const videos_salou = [salou_1, salou_2, salou_3]

const images_peat = require.context('./img/golden/naissance/naissance_peat/current', true);
const imageList3 = images_peat.keys().map(image => images_peat(image));
const videos_peat = [peat_1, peat_2, peat_3]


const Births = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Dernières naissances de chiots golden retriever</title>
        <meta
          name="description"
          content="Retrouvez l'actualité des dernières naissances de chiots golden retriever de travail dans le Puy-de-dôme de l'élevage au travers de photos et de vidéos."
        />
      </Helmet>
      <h1 className='mb-3'>Carnet de naissances</h1>
      <Tabs>
        <Tab eventKey="Salou" title="Salou">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les 8 chiots (2F et 6M) de Salou et Tommy sont arrivés le 20/10.<br/>
                </p>
              </Row>
              <Row>
                <VideoList videos={videos_salou} nom="Salou"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList2} />
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="Peat" title="Peat">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les 14 chiots (6F et 8M) de Peat et Tommy sont arrivés le 02/11.<br/>
                </p>
              </Row>
              <Row>
                <VideoList videos={videos_peat} nom="Peat"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList3} />
              </div>
            </Col>
          </Row>
        </Tab>
      </Tabs>
      <div className='d-flex justify-content-center h-100 w-100 sep'>
        <CarouselGolden imageList={imageList} cN='w-50'/>
      </div>
      <p className='d-flex justify-content-center mt-3'>
        Photos des anciennes portées.
      </p>
    </div>
  );
};

export default Births;
